import lodGoogleMapsApi from "load-google-maps-api";
class GoogleMap {
    static loadGoogleMapsApi() {
        return lodGoogleMapsApi({
            key: "AIzaSyAxl31dPz42KEaTM5n5_5ncCx91u0rbUkE"
        });
    }
    static createMap(googleMaps, mapElement, lat, lng, dType, address) {
        const myLatLng = { lng, lat };
        const map = new googleMaps.Map(mapElement, {
            center: myLatLng,
            //center: { lat: 45.520562, lng: -122.677438 },
            zoom: 14
        });
        new googleMaps.Marker({
            position: myLatLng,
            map,
            title: address
        });
        return map;
    }
}
export default GoogleMap;
